if (!customElements.get('site-drawer')) {
  customElements.define(
    'site-drawer',
    class SiteDrawer extends window.BAO.CustomElement {
      CLASSES = {
        activeDrawerClass: 'drw-Drawer-active'
      }

      constructor () {
        super()

        this.drawers = getElement('site-drawers')

        this._isOpen = false
      }

      connectedCallback () {
        super.connectedCallback()

        if (this.drawerShouldBeMoved) {
          window.setTimeout(() => {
            const moveToElement = this.moveToElement

            this.removeAttribute('data-module-drawers-move-me')

            moveToElement.appendChild(this)
          }, parseInt(this.getAttribute('data-module-drawers-move-delay'), 10) || 0)
        }
      }

      get key () {
        return this.getAttribute('key')
      }

      get elements () {
        return {
          trigger: window.BAO.utils.getElement(
            `[data-drawers-trigger=${this.key}]`
          ),
          close: window.BAO.utils.getElement(`[data-drawers-close=${this.key}]`)
        }
      }

      get isOpen () {
        return this._isOpen
      }

      set isOpen (val) {
        this._isOpen = val

        this.classList.toggle(this.CLASSES.activeDrawerClass, val)
      }

      get drawerShouldBeMoved () {
        return this.hasAttribute('data-module-drawers-move-me')
      }

      get moveToElement () {
        switch (this.getAttribute('data-module-drawers-move-me')) {
          case 'root':
            return this.drawers
          default:
            return getElement(this.getAttribute('data-module-drawers-move-me'))
        }
      }
    }
  )
}
